import { render, staticRenderFns } from "./ElectricMeterPrintPage3.vue?vue&type=template&id=57068c65"
import script from "./ElectricMeterPrintPage3.vue?vue&type=script&lang=js"
export * from "./ElectricMeterPrintPage3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports